import React from 'react';
import SearchBar from '../components/Searchbar';
import YoutubeApi from '../apis/YoutubeApi';
import VideoList from '../components/VideoList';
import VideoDetail from '../components/VideoDetail';
import '../components/Video.css';


class YoutubeScreen extends React.Component {

	state = {
		videos: [],
		selectedVideo: null
	}

	handleSubmit = async (termFromSearchBar) => {
		const response = await YoutubeApi.get('/search', {
			params: {
				q: termFromSearchBar
			}
		})

		this.setState({
			videos: response.data.items
		})
		this.handleVideoSelect(this.state.videos[0]);
	};

	handleVideoSelect = (video) => {
		this.setState({selectedVideo: video})
	}



	render() {
		return (
			<div className='YoutubeContainer'>

				<br/>

				<SearchBar handleFormSubmit={this.handleSubmit}/>

				<div className='ui grid'>
					<div className="ui row">

						<div className="selectedVideoDiv">
							<VideoDetail video={this.state.selectedVideo}/>
						</div>

						<div className="five wide column">
							<VideoList handleVideoSelect={this.handleVideoSelect} videos={this.state.videos}/>
						</div>

					</div>
				</div>
			</div>
		)
	}
}

export default YoutubeScreen;